import type { ElementNodeDto } from '@xshop/shared';
import { isThemePreview } from '../../api/previewVisit';
import { resolveBinding, type StoreFacts } from './storeFacts';

// Names the store in words where its logo would go while it has none, '' while its name is still loading, else null.
export const wordmarkOf = (node: ElementNodeDto, store: StoreFacts | null): string | null =>
  node.bindings?.src === 'store.logo' && store?.logoUrl === '' && !isThemePreview() ? store.storeName.trim() : null;

// Describes the store's own logo by the store's name, not the theme sample's alt ("Argan"), or null while the theme's picture shows.
export const logoDescription = (node: ElementNodeDto, store: StoreFacts | null): string | null =>
  node.bindings?.src === 'store.logo' && !node.bindings.alt && resolveBinding('store.logo', store) !== undefined && store?.storeName.trim()
    ? store.storeName.trim() : null;
